import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
export default function InfoIconButton(_ref) {
  var action = _ref.action,
    onOpen = _ref.onOpen;
  var trigger = function trigger(e) {
    e.stopPropagation();
    onOpen(action);
  };
  return /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: 0,
    className: "shrink-0 cursor-pointer",
    onClick: trigger,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") trigger(e);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "mingcute--information-line",
    className: "text-[#6b7ea5]",
    width: 4,
    height: 4
  }));
}